@if (response$ | async; as response) {
  <ng-container>
    <nexweb-ext-tso-response-form
      [response]="response"
      [labels]="labels"
      [dateTimeFormat]="dateTimeFormat"
      (formValuesChanged)="formValuesChanged($event)"
      (formValidationChanged)="formValidationChanged($event)"></nexweb-ext-tso-response-form>
  </ng-container>
}
